import { Box, Flex } from "@chakra-ui/react";
import { useDynamicModalContext } from "@umami/components";
import { useAddPeer, useCurrentAccount } from "@umami/state";
import { isMultichainEnabled, isSwapEnabled } from "@umami/utils";

import { SendButton } from "./SendButton";
import { ArrowDownLeftIcon, QRCodeIcon, SwapIcon, WalletIcon } from "../../assets/icons";
import { useBuyTokenFlow } from "../../hooks/useBuyTokenFlow";
import { AccountInfoModal } from "../AccountSelectorModal";
import { IconButtonWithText } from "../IconButtonWithText";
import { NetworkSelectorModal } from "../NetworkSelector/NetworkSelectorModal";
import { useOnWalletConnect } from "../WalletConnect";

import { useSwapTokenFlow } from "@/hooks/useSwapTokenFlow";

export const AccountButtons = () => {
  const { openWith } = useDynamicModalContext();
  const currentAccount = useCurrentAccount()!;
  const onBeaconConnect = useAddPeer();
  const onWalletConnect = useOnWalletConnect();
  const { handleAssetSelectClick } = useBuyTokenFlow();
  const { handleSwapClick } = useSwapTokenFlow();

  const handleOnClick = async () => {
    const isEnabled = isMultichainEnabled();

    if (isEnabled) {
      await openWith(<NetworkSelectorModal account={currentAccount} />);
    } else {
      await openWith(<AccountInfoModal account={currentAccount} />);
    }
  };

  return (
    <Box data-testid="account-buttons" paddingX="12px">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap="24px"
        marginTop={{ base: "20px", md: "40px" }}
      >
        <IconButtonWithText
          pointerEvents="auto"
          icon={WalletIcon}
          label="Buy"
          onClick={handleAssetSelectClick}
          variant="iconButtonSolid"
        />
        {isSwapEnabled() ? (
          <IconButtonWithText
            pointerEvents="auto"
            icon={SwapIcon}
            label="Swap"
            onClick={() => handleSwapClick()}
            variant="iconButtonSolid"
          />
        ) : (
          <IconButtonWithText
            icon={QRCodeIcon}
            label="Connect"
            onClick={async () => {
              await navigator.clipboard
                .readText()
                .then(payload =>
                  payload.startsWith("wc:") ? onWalletConnect(payload) : onBeaconConnect(payload)
                );
            }}
            variant="iconButtonSolid"
          />
        )}
        <IconButtonWithText
          icon={ArrowDownLeftIcon}
          label="Receive"
          onClick={handleOnClick}
          variant="iconButtonSolid"
        />
        <SendButton />
      </Flex>
    </Box>
  );
};
